import React from "react";
import logoTools from "../assets/res/tools_logo.gif";
import SearchBar from "./Search";

function Header({ querySearched, onFocusSearched }) {
  return (
    <div className="bg-primary p-6 text-center bottom-0   flex flex-col h-[220px] w-full  shadow-sm bg-gradient-to-br from-blue-600 via-primary to-primary rounded-bl-[20%] rounded-br-[20%] ">
      <div className="flex -mt-[10px]">
        <img src={logoTools} className="w-[100px] h-[100px] mt-[-14px] mx-auto" />
      </div>

      <h1 className="text-2xl bold text-l text-primaryWhite mt-[8px] tracking-wide z-10">
        Tools Mods
      </h1>
      <SearchBar querySearched={querySearched}
        onFocusSearch={onFocusSearched} />
    </div>
  );
}

export default Header;
